import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { LoaderTheme } from '@fcom/ui-components';

import { CarTrawlerWidgetService } from './../../../../services/cartrawler-widget/cartrawler-widget.service';
import { CarTrawlerWidgetStatus } from '../../enums';
import { CarTrawlerClientID } from '../../../../constants';

@Component({
  selector: 'fin-cartrawler-widget',
  templateUrl: './cartrawler-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CarTrawlerWidgetComponent implements OnInit, AfterViewInit {
  readonly LoaderTheme = LoaderTheme;
  readonly CarTrawlerWidgetStatus = CarTrawlerWidgetStatus;

  @Input() order: FinnairOrder;

  @Input() extraClasses = 'mr-large-b';

  @Input() clientId: CarTrawlerClientID;

  containerId = 'car-trawler-widget-container';
  status$: BehaviorSubject<CarTrawlerWidgetStatus> = new BehaviorSubject(CarTrawlerWidgetStatus.INITIAL);

  constructor(
    private carTrawlerWidgetService: CarTrawlerWidgetService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.status$.next(CarTrawlerWidgetStatus.LOADING);
  }

  ngAfterViewInit(): void {
    this.carTrawlerWidgetService.initWidget(this.containerId, this.order, this.clientId).subscribe((isLoaded) => {
      if (isLoaded) {
        this.status$.next(CarTrawlerWidgetStatus.LOADED);
      } else {
        this.status$.next(CarTrawlerWidgetStatus.ERROR);
      }
      this.changeDetectorRef.detectChanges();
    });
  }
}
